<template lang="pug">
#iframe.content.loading-back
  iframe(id="MainPageFrame" name="NetFrame", height="100%", width="100%", frameborder="0", scrolling="no", :src="getModule()", @load='updateHash')
</template>

<script>
/** Allow for iframe interoperation */
if (document.domain) {
  document.domain = window.location.hostname
}

export default {
  updated() {
    if (global.document.getElementById('MainPageFrame')) global.document.getElementById('MainPageFrame').style.width = '1240px'
  },
  data() {
    return {
      uri: process.env.NET_GATEWAY.replace(/:[0-9]+\//, '/') + '/',
      module: this.$route.params.page
    }
  },
  methods: {
    updateHash() {
      /* var currentModule = window.frames['NetFrame'].location.href.replace(this.uri, '')

      if (currentModule !== this.$route.params.page) {
        window.location.hash = '/' + this.$route.params.namespace + '/' + currentModule
      } */
      setTimeout(() => {
        global.document.getElementById('MainPageFrame').style.width = '100%'
        global.frames['NetFrame'].document.body.style.width = '100%'
      }, 500)
    },
    getModule() {
      // return this.uri + this.$route.params.page
      return this.uri + this.$route.params.section + (this.$route.params.action ? '/' + this.$route.params.action : '')
    }
  }
}
</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

#MainPageFrame {
  display: block;
  margin: 0 auto;
  width: 1240px;
}

.loading-back {
  &:before {
    position: absolute;
    top: 50%;
    left: 50%;
    font: 50px 'Font Awesome 5 Regular';
    content: '\f1ce';
    z-index: 10000;
    animation: fa-spin 1s infinite linear;
    color: t(primary-04);
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left : 0;
    width: 100%;
    height: 100%;
    display: block;
    opacity: .55;
    z-index: 9999;
  }
}

</style>



// WEBPACK FOOTER //
// index.vue?09aa96b2